import React, { useEffect, useRef } from "react";
import cloud from "../assets/cloud-box.svg";
import wbox from "../assets/w-box.svg";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const API = () => {
  gsap.registerPlugin(ScrollTrigger);

  const ref = useRef(null);

  const timeline = gsap.timeline();

  useEffect(() => {
    const element = ref.current;

    timeline.from(element.querySelector("#left"), {
      duration: 1.5,
      opacity: 1,
      y: -60,
      ease: "none",
      scrollTrigger: {
        trigger: element.querySelector("#api"),
        start: "80px 100%",
        end: "+=200",
        scrub: true,
      },
    });
    timeline.from(element.querySelector("#right"), {
      duration: 1,
      opacity: 1,
      y: 60,
      delay: 0.4,
      stagger: {
        amount: 0.2,
      },
      ease: "none",
      scrollTrigger: {
        trigger: element.querySelector("#api"),
        start: "80px 100%",
        end: "+=200",
        scrub: true,
      },
    });
  });

  return (
    <div
      id="documentation"
      ref={ref}
      className="w-full bg-[#f7f7f7] py-24 px-14 sm:px-6 lg:px-36 mb-12"
    >
      <div className="grid sm:grid-cols-2 gap-4" id="api">
        <div className="flex flex-col items-center sm:items-start" id="left">
          <h1>WalletCloud API</h1>
          <p className="mt-6 text-[#828282] text-justify w-11/12">
            Connect to our blockchain wallet service and seamlessly carry out
            transactions. Securely initiate crypto transactions, and store them
            with one simple integration.
          </p>
        </div>
        <div
          className="pt-6 sm:pt-0 sm:px-8 flex flex-col items-center"
          id="right"
        >
          <div className="item-center flex flex-row">
            <img src={cloud} alt="cloud" className="mr-6" />
            <div className="flex flex-col">
              <h3 className="text-[#219653]">Networks</h3>
              <p className="text-[#828282] md:text-justify">
                WalletCloud provides support for the Ethereum Mainnet and
                Rinkeby Testnet.
              </p>
            </div>
          </div>
          <div className="item-center flex flex-row">
            <img src={wbox} alt="cloud" className="mr-6" />
            <div className="flex flex-col mt-4">
              <h3 className="text-[#219653]">Asset Management</h3>
              <p className="text-[#828282] text-justify sm:text-left md:text-justify">
                WalletCloud provides support for sending and receiving the
                assets listed in the table below on the Ethereum Mainnet and
                Testnet. Support for more assets will be added subsequently.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default API;
